import { z } from 'zod';

import { makeEndpoint } from '../common';

export const LimitedTimeSchema = z.object({
  id: z.string(),
  ticketSalesOpenAt: z.union([z.date().transform((date) => date.toISOString()), z.string().datetime()]).nullable(),
  ticketSalesCloseAt: z.union([z.date().transform((date) => date.toISOString()), z.string().datetime()]).nullable(),
  active: z.boolean(),
  createdAt: z.date(),
});

export type LimitedTime = z.infer<typeof LimitedTimeSchema>;

export const PostLimitedTimeSchema = z.object({
  ticketSalesOpenAt: z.union([z.date().transform((date) => date.toISOString()), z.string().datetime()]).nullable(),
  ticketSalesCloseAt: z.union([z.date().transform((date) => date.toISOString()), z.string().datetime()]).nullable(),
  active: z.boolean().optional().nullable(),
});

export const PostLimitedTimeResponseSchema = LimitedTimeSchema.pick({
  id: true,
});

export const PostLimitedTimeEndpoint = makeEndpoint({
  method: 'POST',
  url: () => 'v1/limited-time',
  requestSchema: PostLimitedTimeSchema,
  responseSchema: PostLimitedTimeResponseSchema,
});

export const GetLimitedTimeEndpoint = makeEndpoint({
  method: 'GET',
  description: 'Get a limited time  by ID.',
  url: ({ id }: { id: string }) => `v1/limited-time/${id}`,
  requestSchema: z.void(),
  responseSchema: LimitedTimeSchema,
});
